import * as SmartDrawings from "../../smartDrawings";

/**
 * Utilities for reading and writing settings from the local storage.
 */
export namespace SettingsUtils {

    export const settingsMap: SmartDrawings.SettingsMap = {
        /*"number": { label: "Number", type: "number", default: 5 },
        "bool": { label: "Bool", type: "boolean", default: true },
        "enum": {
            label: "Enum",
            type: "enum",
            values: [
                { value: "a", label: "A" }, { value: "b", label: "B" },
                { value: "c", label: "C" }
            ],
            default: "b"
        },*/
        "coordGrid": { label: "Draw coordinate grid (requires reload)", type: "boolean", default: false },
        "ghosting": { label: "Ghost hidden objects", type: "boolean", viewerSetting: true, default: true },
        "buildOrderInterval": { label: "Build order step interval (s)", type: "number", default: 0.5 },
        "searchZoom": { label: "Zoom to fit from quick search", type: "boolean", default: false },
        "hideGrid": { label: "Hide module grid from all models, if found (requires reload)", type: "boolean", default: false }
    };

    export function loadSettings(settingsMap: SmartDrawings.SettingsMap) {
        const values = {};
        for (let name in settingsMap) {
            const setting = settingsMap[name];
            let val = localStorage.getItem(fullSettingsName(name, setting)) || setting.default;
            if (setting.type === "boolean") {
                if (typeof val === "string") {
                    val = val === "true";
                } 
            }
            values[name] = val;
        }
        return values;
    }

    export function loadSingleSetting(name: string) {
        try {
            const setting = settingsMap[name];
            let val = localStorage.getItem(fullSettingsName(name, setting)) || setting.default;
            if (setting.type === "boolean") {
                val = val === "true";
            }
            return val;
        } catch (e) {
            // Probably sandboxed, no local storage access.
            return null;
        }
    }

    export function saveSettings(values, settingsMap: SmartDrawings.SettingsMap) {
        for (let name in values) {
            if (values.hasOwnProperty(name)) {
                localStorage.setItem(fullSettingsName(name, settingsMap[name]), values[name]);
            }
        }
    }

    export function defaultSettings(settingsMap: SmartDrawings.SettingsMap) {
        const values = {};
        for (let name in settingsMap) {
            const setting = settingsMap[name]; 
            values[name] = setting.default;
        }
        return values;
    }

    function fullSettingsName(name: string, setting?: SmartDrawings.Setting): string {
        if (setting != null && setting.viewerSetting) {
            return "Autodesk.Viewing.GuiViewer3D.SavedSettings." + name;
        }
        return `SmartDrawings.SavedSettings.${name}`;
    }


}